import React from 'react';
import { IconRuler2 } from '@tabler/icons';
import SimpleLookupCrud from './SimpleLookupCrud';

const UnitsOfMeasure = () => (
    <SimpleLookupCrud
        icon={IconRuler2}
        gradient="blue"
        title="Unidades de Medida"
        subtitle="Unidades usadas em produtos e serviços (UN, KG, CX...)"
        endpoint="units-of-measure"
        addLabel="Nova unidade"
        columns={[
            { key: 'code', label: 'Código', type: 'text', required: true },
            { key: 'name', label: 'Nome', type: 'text', required: true }
        ]}
    />
);

export default UnitsOfMeasure;
